import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography'
//import { LineChart } from '@mui/x-charts/LineChart';
import { useState } from 'react';
import styled from 'styled-components';

import { Chart as ChartJS, CategoryScale, LinearScale, PointElement, LineElement, Title, Tooltip, Legend } from "chart.js";
import { Line } from "react-chartjs-2";
ChartJS.register(CategoryScale, LinearScale, PointElement, LineElement, Title, Tooltip, Legend);
/*function Graph({ graphData = {}, type = 'daily', width = 1400, height = 300 }) {

    const defaultData = {
        data: new Array(24).fill(0),
        labels: Array.from({ length: 24 }, (_, i) => i.toString().padStart(2, "0"))
    };

    const finalData = {
        data: graphData.data || defaultData.data,
        labels: graphData.labels || defaultData.labels
    };

    const allZero = finalData.data.every(value => Number(value) === 0);

    return (
        <Container>
            <Typography variant="h6" component="h2" gutterBottom align="center">
                {type === 'daily' ? 'Consumo por bandas horarias' : 'Consumo por dias del mes'}
            </Typography>

            <LineChart
                width={width}
                height={height}
                series={[
                    {
                        data: finalData.data,
                        label: 'kWh',
                        yAxisId: 'leftAxisId',
                        curve: 'linear',
                        color: '#FFA500',
                    }
                ]}
                xAxis={[
                    {
                        scaleType: 'point',
                        data: finalData.labels,
                        height: 52,
                        label: type === 'daily' ? 'Hora' : 'Dia'
                    }
                ]}
                yAxis={[
                    {
                        id: 'leftAxisId',
                        min: 0,
                        max: allZero ? 5 : undefined,
                        width: 70,
                        label: 'Consumo kWh'
                    },
                    {
                        id: 'rightAxisId',
                        position: 'right'
                    },
                ]}
            />
        </Container>
    )
}*/

function Graph({ graphData = {}, type = 'daily', reported = [], width = 800, height = 400, highlightIndex = null }) {

    const defaultData = {
        data: new Array(24).fill(0),
        labels: Array.from({ length: 24 }, (_, i) => i.toString().padStart(2, "0"))
    };

    const finalData = {
        data: graphData.data || defaultData.data,
        labels: graphData.labels || defaultData.labels
    };

    let pointColors = new Array(finalData.data.length).fill("#FFA500");
    for (let i = 0; i < reported.length; i++) {
        pointColors[i] = reported[i] ? "#FFA500" : "#e03737ff"; 
    }
    
    //const pointColors = finalData.data.map((_, index) => index === highlightIndex ? "#e03737ff" : "#FFA500");


    const data = {
        labels: finalData.labels,
        datasets: [{
            label: type === 'daily' ? 'Consumo por bandas horarias' : 'Consumo por dias del mes',
            data: finalData.data,
            borderColor: "#FFA500",
            backgroundColor: "#FFA500",
            borderWidth: 2,
            pointBackgroundColor: pointColors,
            pointBorderColor: pointColors,
            pointRadius: 3,
            pointHoverRadius: 4,
            tension: 0.3,
        }]
    };
    const options = {
        responsive: true,
        maintainAspectRatio: false,
        interaction: {
            mode: 'index',
            intersect: false,
        },
        plugins: {
            legend: { 
                display: true,
                onClick: ()=>{}
            },
            tooltip: { callbacks: { label: function (context) { return `Consumo: ${context.parsed.y} kWh`; } } }
        },
        scales: {
            x: { 
                title: { 
                    display: true, 
                    text: type === 'daily' ? 'Hora' : 'Dia'
                } 
            },
            y: { 
                beginAtZero: true, 
                title: { 
                    display: true, 
                    text: "Consumo (kWh)" 
                } 
            }
        }
    };
    return (
        <Container>
            <Line data={data} options={options} />
        </Container>
    );
}

const Container = styled.div`
    background: ${(props) => props.theme.body};
    box-sizing: border-box;
    padding: 10px;
    width: 100%;
    height: 40vh;
    border-radius: 8px;
    box-shadow: 2px 2px 5px rgba(0, 0, 0, .3);
`

export default Graph

/*
import { axisClasses } from '@mui/x-charts/ChartsAxis'

<LineChart
                series={[
                    {
                    data: uData,
                    label: 'kWh',
                    yAxisId: 'leftAxisId',
                    curve: 'linear', // Línea recta
                    color: '#FFA500', // Color azul
                    }
                ]}
                xAxis={[{ scaleType: 'point', data: xLabels, height: 52, label: 'Horas del dia', labelStyle: { fill: 'white'} }]}
                yAxis={[
                    { id: 'leftAxisId', width: 70, label: 'Consumo kWh', labelStyle: { fill: 'white',} },
                    { id: 'rightAxisId', position: 'right' },
                ]}
                sx={{
                [`.${axisClasses.root}`]: {
                    // Estilo para las líneas y ticks del eje
                    [`.${axisClasses.tick}, .${axisClasses.line}`]: {
                    stroke: '#9e9e9e', // Gris claro para las líneas
                    strokeWidth: 1,
                    },
                    // Estilo para las etiquetas de los ticks (el texto)
                    [`.${axisClasses.tickLabel}`]: {
                    fill: 'white', // Blanco para el texto
                    },
                },
                }}
            />

*/